import React, { Component, ReactElement, ReactNode } from "react";
import _ from "lodash";
import classnames from "classnames";
import { Transition } from "react-transition-group";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from "react-accessible-accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSearch,
    faExternalLink,
    faChevronRight,
    faChevronUp,
} from "@fortawesome/pro-light-svg-icons";
import { faChild, faFilter } from "@fortawesome/pro-solid-svg-icons";

import { Props } from "../../propTypes";
import {
    eGroupFilter,
    processedEGroupFilterContent,
    egroupFilterValue,
} from "../../../store/egroups/types";
import { ObjectLiteral } from "../../../constants";

import ConditionalWrapper from "../../general/ConditionalWrapper";
import ClickAwayListener from "../../general/ClickAwayListener";
// import timeZones from '../../general/timeZones';
import Image from "next/image";

import {
    library,
    IconProp,
    IconDefinition,
} from "@fortawesome/fontawesome-svg-core";
import { getKeyValue } from "../../../globalTypes";
import { Helpers } from "../common/helpers";

library.add(faChild, faFilter);

export type eGroupFiltersValues = {
    filters: processedEGroupFilterContent[];
    timeProcessed: number;
};

type State = {
    expandedFilters: string[];
    expandedFiltersRaw: string[];
    positionFixed: boolean;
    query: ObjectLiteral;
    matches: ObjectLiteral;
    showNoResults: string[];
    selectedFilters: ObjectLiteral[];
    selectedFiltersRaw: ObjectLiteral[];
};

type PropsParams = {
    windowDimensions: ObjectLiteral;
    changeFunction: Function;
    clearFunction: Function;
    selectedFilters: ObjectLiteral[];
    eGroupFiltersValues: eGroupFiltersValues | null;
    expandedFilters: string[];
    isLoaded: boolean;
    isLoading: boolean;
    clearFilters: Function;

    extraAccordionButtonClass?: string;
    extraAccordionPanelClass?: string;
    extraSwitchFilterClass?: string;
    extraWrapperFiltersClass?: string;
    extraLogoClass?: string;
    mobileRedirectToOtherViewIcon?: IconDefinition;
    mobileRedirectToOtherViewUrl?: string;
    mobileRedirectToOtherViewTitle?: string;

    selectedTimeZone?: string[];
    changeTimezone?: Function;
    clearTimezone?: Function;

    isScollAfterHeader?: boolean;
};

//Animation constants
const duration = 300;
const defaultStyle = {
    transition: `all ${duration}ms ease-in-out`,
    opacity: 0,
    maxHeight: 0,
    width: "100%",
};
const transitionStyles: ObjectLiteral = {
    entering: { opacity: 1, maxHeight: 10000 },
    entered: { opacity: 1, maxHeight: 10000 },
    exiting: { opacity: 0, maxHeight: 0 },
    exited: { opacity: 0, maxHeight: 0 },
};

const defaultStyleTopic = {
    transition: `all ${duration}ms ease-in-out`,
    opacity: 0,
};
const transitionTopicStyles: ObjectLiteral = {
    entering: { opacity: 0, display: "block" },
    entered: { opacity: 1 },
    exiting: { opacity: 1 },
    exited: { opacity: 0, display: "none" },
};

export default class Filters extends Component<Props & PropsParams, State> {
    sideBarRef = React.createRef<HTMLDivElement>();

    state: State = {
        expandedFilters: [],
        expandedFiltersRaw: [],
        positionFixed: false,
        query: {},
        matches: [],
        showNoResults: [],
        selectedFilters: [],
        selectedFiltersRaw: [],
    };
    helpers = new Helpers();
    totalCharsTag = 21;

    componentDidUpdate() {
        if (
            !_.isEqual(
                this.state.expandedFiltersRaw,
                this.props.expandedFilters
            )
        ) {
            this.setState({
                expandedFilters: _.union(
                    this.state.expandedFilters,
                    this.props.expandedFilters
                ),
                expandedFiltersRaw: this.props.expandedFilters,
            });
        }

        if (
            !_.isEqual(
                this.state.selectedFiltersRaw,
                this.props.selectedFilters
            )
        ) {
            const selectedFilters: ObjectLiteral[] = [];

            this.props.selectedFilters.forEach((selectedFilter) => {
                if (selectedFilter.content && selectedFilter.content.length) {
                    selectedFilter.content.forEach((filterValue: string) => {
                        let valuesToAdd = [filterValue];

                        if (filterValue.indexOf("--") > -1) {
                            const valuePieces = filterValue.split("--");
                            if (
                                valuePieces.length > 2 &&
                                selectedFilter.demographic
                            ) {
                                valuePieces.splice(0, 1); // remove the first element - this is a fix for demographic
                            }

                            valuesToAdd = [
                                valuePieces[0],
                                valuePieces.join("--"),
                            ];
                        }

                        const filterIndex = _.findIndex(selectedFilters, {
                            name: selectedFilter.name,
                        });

                        if (filterIndex > -1) {
                            selectedFilters[filterIndex].content.push(
                                ...valuesToAdd
                            );
                        } else {
                            selectedFilters.push({
                                name: selectedFilter.name,
                                content: valuesToAdd,
                            });
                        }
                    });
                }
            });

            this.setState({
                selectedFilters,
                selectedFiltersRaw: _.cloneDeep(this.props.selectedFilters),
            });
        }
    }

    showNoResults = (filterName: string) => {
        const index = _.indexOf(this.state.showNoResults, filterName);
        let newShowNoResults: string[] = [];

        if (index > -1) {
            newShowNoResults = _.without(this.state.showNoResults, filterName);
        } else {
            newShowNoResults = [...this.state.showNoResults, filterName];
        }

        this.setState({
            showNoResults: newShowNoResults,
        });
    };

    clearQuery(i: string, filterSlugName: string) {
        const { query, matches } = this.state;

        if (this.props.changeFunction) {
            this.props.changeFunction(filterSlugName, i);
        }

        if (query || !_.isEmpty(matches[filterSlugName])) {
            const newQuery = {
                ...query,
            };

            newQuery[filterSlugName] = "";

            const newMatches = {
                ...matches,
            };
            newMatches[filterSlugName] = [];

            this.setState({
                query: newQuery,
                matches: newMatches,
            });
        }
    }

    collapseAccordion = () => {
        this.setState({
            expandedFilters: [],
            expandedFiltersRaw: [],
        });

        this.props.clearFilters();
    };

    searchListItemToShow(
        key: number,
        item: egroupFilterValue,
        selected: boolean,
        filterSlugName: string,
        filterName: string,
        removeOnClickSelected: boolean
    ) {
        return (
            <li
                key={key}
                className={classnames(
                    `list-filter regular prim-font flex flex-align-center flex-justify-spacebetween cursor-pointer p-spacer-xs`,
                    {
                        active: selected,
                    },
                    {
                        noContent:
                            item.count === 0 &&
                            item.value !==
                                process.env.NEXT_PUBLIC_EC_TORONTO_CAMPUS_VALUE,
                    }
                )}
                onClick={() => {
                    if (
                        (!selected || (selected && removeOnClickSelected)) &&
                        item.value !==
                            process.env.NEXT_PUBLIC_EC_TORONTO_CAMPUS_VALUE
                    )
                        this.clearQuery(item.value.toLowerCase(), filterName);
                    // this.props.router.push({
                    //     pathname: `egroups/${item.value.toLowerCase()}`,
                    // });

                    if (
                        item.value ===
                            process.env.NEXT_PUBLIC_EC_TORONTO_CAMPUS_VALUE &&
                        process.browser
                    )
                        window.location.href =
                            process.env.NEXT_PUBLIC_EC_TORONTO_URL;
                }}
            >
                <span
                    id={`cc-egroups-search-${filterSlugName.toLowerCase()}-${item.value
                        .toLowerCase()
                        .replace(/ /g, "-")}`}
                    className="full-width"
                >
                    {item.label}{" "}
                    {item.value !==
                    process.env.NEXT_PUBLIC_EC_TORONTO_CAMPUS_VALUE ? (
                        <span className="text-trans-alt-dark-grey">
                            {item.count}
                        </span>
                    ) : null}
                </span>
                <span className="p-r-spacer-md not-clickable">
                    <FontAwesomeIcon
                        className="font-size-14 list-filter-icon"
                        icon={faChevronRight}
                        size="1x"
                    />
                </span>
            </li>
        );
    }

    handleSearch(
        event: React.ChangeEvent<HTMLInputElement>,
        filter: eGroupFilter,
        filterSlugName: string
    ) {
        const valueMatches = filter.values.filter(function (el) {
            let searchValue = el.label.toLowerCase();

            return searchValue.indexOf(event.target.value.toLowerCase()) !== -1;
        });

        const query = {
            ...this.state.query,
        };

        query[filterSlugName] = event.target.value.toLowerCase();

        const matches = {
            ...this.state.matches,
        };

        matches[filterSlugName] = valueMatches;

        this.setState({
            query,
            matches,
        });
    }

    getFilterContent = (filter: processedEGroupFilterContent) => {
        const filterSlugName = filter.name?.replaceAll(" ", "-");

        switch (filter.displayType) {
            case "list":
                return this.getListFilterContent(filter, filterSlugName, true);
            case "tagSelector":
                const defaultValues = this.helpers.mapFilterValues(
                    this.props.eGroups.eGroupDefaultFilters,
                    this.props.eGroups.eGroupHomeData
                );

                let index = -1;

                if (defaultValues) {
                    index = _.findIndex(defaultValues.filters, {
                        name: filter.name,
                    });
                }

                return this.getTagSelectorFilterContent(
                    filter,
                    filterSlugName,
                    true,
                    index > -1 ? defaultValues?.filters[index].values : []
                );
            case "demographicSelector":
                return this.getDemographicSelectorSelectorFilterContent(
                    filter,
                    filterSlugName
                );
            case "campusList":
                return this.getCampusListFilterContent(filter, filterSlugName);
            default:
                return null;
        }
    };

    getFilterToUse = (filter: processedEGroupFilterContent) => {
        switch (filter.displayType) {
            case "campusList":
                const valuesToUse: egroupFilterValue[] =
                    this.props.main.campuses
                        .filter((campus) => {
                            return (
                                campus.active ||
                                campus.id ==
                                    process.env.NEXT_PUBLIC_EC_TORONTO_CAMPUS_ID
                            );
                        })
                        .map((campus) => {
                            let campusIndex = _.findIndex(filter.values, {
                                value: campus.id,
                            });

                            return {
                                // campus,
                                value: campus.slugName,
                                label: campus.name,
                                count:
                                    campusIndex > -1
                                        ? filter.values[campusIndex].count
                                        : 0,
                            } as egroupFilterValue;
                        });
                // .filter(
                //     (a) =>
                //         a.value !==
                //         (process.env
                //             .NEXT_PUBLIC_EC_TORONTO_CAMPUS_VALUE as string)
                // );

                const filterToUse = {
                    ...filter,
                    values: valuesToUse,
                };

                return filterToUse;
            default:
                return filter;
        }
    };

    getCampusListFilterContent = (
        filterToUse: eGroupFilter,
        filterSlugName: string
    ) => {
        let extraContent: ReactNode = null;

        if (
            ((this.state.query[filterToUse.name] &&
                process.env.NEXT_PUBLIC_EC_TORONTO_CAMPUS_VALUE &&
                (process.env.NEXT_PUBLIC_EC_TORONTO_CAMPUS_VALUE as string)
                    .toLowerCase()
                    .includes(
                        this.state.query[filterToUse.name].toLowerCase()
                    )) ||
                !this.state.query[filterToUse.name]) &&
            process.env.NEXT_PUBLIC_EC_TORONTO_URL
        ) {
            extraContent = (
                <li className="p-spacer-sm m-t-spacer-xl">
                    <a
                        href={process.env.NEXT_PUBLIC_EC_TORONTO_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover-grow ec-border-radius-sm prim-font ec-primary-font--regular text-dark background-trans-light-grey p-spacer-md no-border full-width text-left flex-justify-between flex flex-align-center"
                    >
                        Find groups in Toronto
                        <FontAwesomeIcon icon={faExternalLink} />
                    </a>
                </li>
            );
        }

        const values = filterToUse.values.sort((a, b) => {
            const nameA = a.label.toUpperCase(); // ignore upper and lowercase
            const nameB = b.label.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            return 0;
        });

        return this.getListFilterContent(
            filterToUse,
            filterSlugName,
            false,
            extraContent
        );
    };

    getListFilterContent = (
        filter: eGroupFilter,
        filterSlugName: string,
        removeOnClickSelected: boolean,
        extraContent?: ReactNode
    ) => {
        return (
            <section
                id={`${filterSlugName.toLowerCase()}-filters`}
                className="full-width mob-p-x-spacer-md"
                key={`${filterSlugName.toLowerCase()}-filters`}
            >
                <div className="m-t-spacer-sm full-width rel-pos p-r-spacer-md">
                    <input
                        placeholder={`Search ${filter.label}`}
                        className="ht-36 full-width m-y-spacer-md background-off-white ec-border-radius-sm b-width-none p-l-spacer-sm p-r-spacer-xl"
                        value={this.state.query[filter.name] || ""}
                        onChange={(e) =>
                            this.handleSearch(e, filter, filter.name)
                        }
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        className="abs-pos abs-y-center stayright m-r-spacer-md"
                    />
                </div>
                {this.renderListOptions(
                    filter,
                    filterSlugName,
                    removeOnClickSelected,
                    extraContent
                )}
            </section>
        );
    };

    getDemographicSelectorSelectorFilterContent = (
        filter: eGroupFilter,
        filterSlugName: string
    ) => {
        const defaultValues = this.helpers.mapFilterValues(
            this.props.eGroups.eGroupDefaultFilters,
            this.props.eGroups.eGroupHomeData
        );

        const getName = (value: string) => {
            if (value === "Youth") {
                return "Seasonal";
            }

            if (value.indexOf("Youth - ") > -1) {
                return value.replace("Youth - ", "");
            }

            return value;
        };

        const getChildren = (
            filterData: egroupFilterValue,
            modifyValue = false
        ): egroupFilterValue[] => {
            return filterData.children
                .filter((child) => {
                    return child.value;
                })
                .map((child) => {
                    return {
                        ...child,
                        value: modifyValue
                            ? `${filterData.value}--${child.value}`
                            : child.value,
                        label: getName(child.value),
                        children: getChildren(child),
                    };
                });
        };

        return (
            <div
                className={classnames({
                    "xl-list-p-b overflow-auto-mob ht-1000 hide-scrollbars":
                        this.props.windowDimensions.width <
                        this.props.main.desktopMinSize,
                })}
                key={`${filterSlugName}-${Date()}`}
            >
                {filter.values.map((filterData, index) => {
                    const children = getChildren(filterData, true);

                    const newFilterToUse = {
                        ...filter,
                        values: this.helpers.eGroupFilterValuesSorter(
                            children,
                            filter
                        ),
                    };

                    if (!filterData.label) {
                        return null;
                    }

                    let newDefaultFilterToUse: egroupFilterValue[] = [];

                    if (defaultValues) {
                        const filterPos = _.findIndex(defaultValues.filters, {
                            name: filter.name,
                        });

                        if (filterPos > -1) {
                            const pos = _.findIndex(
                                defaultValues.filters[filterPos].values,
                                { value: filterData.value }
                            );
                            newDefaultFilterToUse = getChildren(
                                defaultValues.filters[filterPos].values[pos],
                                true
                            );
                        }
                    }

                    return (
                        <div
                            className={`mob-p-x-spacer-md${
                                this.props.windowDimensions.width >
                                this.props.main.desktopMinSize - 1
                                    ? `${filterSlugName}-filter-section-border`
                                    : ""
                            }`}
                            key={`${filter.name}-${filter.id}-${index}`}
                        >
                            <p className="sec-font font-size-12 ec-text-grey m-spacer-none m-t-spacer-md mob-font-size-16">
                                {filterData.label.replace(" Group", "")}
                            </p>
                            <div className="flex flex-wrap">
                                {this.getTagSelectorFilterContent(
                                    newFilterToUse,
                                    filterSlugName,
                                    false,
                                    newDefaultFilterToUse
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    getTagSelectorFilterSingleContent = (
        filter: eGroupFilter,
        filterValue: egroupFilterValue,
        filterSlugName: string,
        index: number,
        disabled: boolean
    ) => {
        const filterPos = _.findIndex(this.state.selectedFilters, {
            name: filter.name,
        });
        let isFilterSelected = false;

        if (filterPos > -1) {
            isFilterSelected = this.state.selectedFilters[
                filterPos
            ].content.includes(filterValue.value.toLowerCase());
        }

        const isChildSelected =
            filterValue.children.filter((child) => {
                return (
                    filterPos > -1 &&
                    this.state.selectedFilters[filterPos].content &&
                    _.indexOf(
                        this.state.selectedFilters[filterPos].content,
                        `${filterValue.value.toLowerCase()}--${child.value.toLowerCase()}`
                    ) > -1
                );
            }).length > 0;

        if (isChildSelected) {
            isFilterSelected =
                _.findIndex(this.state.selectedFilters, {
                    name: filter.name,
                    content: [filterValue.value.toLowerCase()],
                }) > -1;
        }

        return (
            <React.Fragment key={`${filterSlugName}-${index}`}>
                <div
                    key={index}
                    className={classnames({
                        "flex flex-row flex-wrap":
                            filterValue.children.length > 0,
                    })}
                >
                    <button
                        onClick={() => {
                            if (disabled) {
                                return false;
                            } else {
                                let selectedFilters: ObjectLiteral[] = [];
                                const copyChildrenArray =
                                    this.state.selectedFilters.slice();
                                const indexFilter = _.findIndex(
                                    copyChildrenArray,
                                    {
                                        name: filter.name,
                                    }
                                );

                                if (filterValue.children.length > 0) {
                                    if (isFilterSelected) {
                                        if (indexFilter > -1) {
                                            const indexValue =
                                                copyChildrenArray[
                                                    indexFilter
                                                ].content.indexOf(
                                                    filterValue.value.toLowerCase()
                                                );

                                            if (indexValue > -1) {
                                                copyChildrenArray[
                                                    indexFilter
                                                ].content.splice(
                                                    copyChildrenArray[
                                                        indexFilter
                                                    ].content.indexOf(
                                                        filterValue.value.toLowerCase()
                                                    ),
                                                    1
                                                );
                                            } else {
                                                copyChildrenArray[
                                                    indexFilter
                                                ].content.push(
                                                    filterValue.value.toLowerCase()
                                                );
                                            }
                                        }
                                    } else {
                                        if (indexFilter > -1) {
                                            copyChildrenArray[
                                                indexFilter
                                            ].content = [
                                                ...copyChildrenArray[
                                                    indexFilter
                                                ].content,
                                                filterValue.value.toLowerCase(),
                                            ];
                                        } else {
                                            copyChildrenArray.push({
                                                name: filter.name,
                                                content: [
                                                    filterValue.value.toLowerCase(),
                                                ],
                                            });
                                        }
                                    }
                                    selectedFilters = copyChildrenArray;
                                    this.setState({
                                        selectedFilters,
                                    });
                                } else {
                                    // selectedFilters = this.state.selectedFilters
                                    //     .slice()
                                    //     .push();
                                    if (
                                        this.props.changeFunction &&
                                        _.isFunction(this.props.changeFunction)
                                    ) {
                                        this.props.changeFunction(
                                            filter.name,
                                            filterValue.value.toLowerCase()
                                        );
                                    }
                                }
                            }
                        }}
                        id={`cc-egroups-search-${filterSlugName.toLowerCase()}--${filterValue.value
                            .toLowerCase()
                            .replace(/ /g, "-")}`}
                        className={classnames(
                            "filters-pill ln-height-reset cursor-pointer ec-primary-font--regular prim-font",
                            {
                                "no-border": !(
                                    isFilterSelected && isChildSelected
                                ),
                                active:
                                    isFilterSelected &&
                                    filterValue.children.length === 0,
                                selected:
                                    isChildSelected &&
                                    filterValue.children.length > 0,
                                disabled: disabled && !isFilterSelected,
                            }
                        )}
                        title={filterValue.label}
                    >
                        {`${filterValue.label.substr(0, this.totalCharsTag)}${
                            filterValue.label.length > this.totalCharsTag
                                ? "..."
                                : ""
                        }`}
                        {filterValue.children.length > 0 ? (
                            <FontAwesomeIcon
                                className={classnames(
                                    "rotate m-l-spacer-sm font-size-14",
                                    {
                                        down: !isFilterSelected,
                                    }
                                )}
                                icon={faChevronUp}
                            />
                        ) : null}
                    </button>
                </div>
                {filterValue.children.map((child, childIndex) => {
                    const isChildSelected =
                        _.indexOf(
                            this.state.selectedFilters[filterPos] &&
                                this.state.selectedFilters[filterPos].content,
                            `${filterValue.value.toLowerCase()}--${child.value.toLowerCase()}`
                        ) > -1;

                    return (
                        <Transition
                            in={isFilterSelected}
                            timeout={0}
                            key={`${filterValue.value.toLowerCase()}--${childIndex}`}
                        >
                            {(state: string | number) => (
                                <div
                                    style={{
                                        ...defaultStyleTopic,
                                        ...transitionTopicStyles[state],
                                    }}
                                >
                                    <button
                                        onClick={() => {
                                            this.props.changeFunction(
                                                filter.name,
                                                `${filterValue.value.toLowerCase()}--${child.value.toLowerCase()}`
                                            );
                                        }}
                                        id={`cc-egroups-search-${filterSlugName.toLowerCase()}-${child.label.replace(
                                            / /g,
                                            "-"
                                        )}`}
                                        className={classnames(
                                            "filters-pill ln-height-reset cursor-pointer b-width-none regular prim-font white b-width-xs border-grey",
                                            {
                                                active: isChildSelected,
                                            }
                                        )}
                                        title={child.label.replace(
                                            `${filterValue.label} - `,
                                            ""
                                        )}
                                    >
                                        {`${child.label
                                            .replace(
                                                `${filterValue.label} - `,
                                                ""
                                            )
                                            .substr(0, this.totalCharsTag)}${
                                            child.label.replace(
                                                `${filterValue.label} - `,
                                                ""
                                            ).length > this.totalCharsTag
                                                ? "..."
                                                : ""
                                        }`}
                                    </button>
                                </div>
                            )}
                        </Transition>
                    );
                })}
            </React.Fragment>
        );
    };

    getTagSelectorFilterContent = (
        filter: eGroupFilter,
        filterSlugName: string,
        useWrapper = true,
        defaultValuesFilters?: egroupFilterValue[]
    ) => {
        const valuesToUse = filter.values.slice(0).map((filterValue) => {
            let showChildren = true;
            const children = filterValue.children.filter((child) => {
                return child.value;
            });
            if (children.length === 1) {
                const value = filterValue.children[0].value;
                if (
                    value.replace(`${filterValue.value} - `, "") ===
                    filterValue.value
                ) {
                    showChildren = false;
                }
            }

            return {
                ...filterValue,
                children: showChildren ? children : [],
            };
        });
        let disabledValues: egroupFilterValue[] = [];

        if (defaultValuesFilters && defaultValuesFilters.length > 0) {
            disabledValues = defaultValuesFilters.filter((obj) => {
                return _.findIndex(valuesToUse, { value: obj.value }) === -1;
            });
        }
        const selectedFilter = _.findIndex(this.state.selectedFilters, {
            name: filter.name,
        });

        const content: ReactElement = (
            <>
                {valuesToUse.map((filterValue, index) => {
                    if (!filterValue.value) {
                        return null;
                    }

                    return this.getTagSelectorFilterSingleContent(
                        filter,
                        filterValue,
                        filterSlugName,
                        index,
                        false
                    );
                })}

                {disabledValues.map((filterValue, index) => {
                    if (!filterValue.value) {
                        return null;
                    }

                    return this.getTagSelectorFilterSingleContent(
                        filter,
                        filterValue,
                        filterSlugName,
                        index,
                        selectedFilter === -1
                    );
                })}
            </>
        );

        return (
            <ConditionalWrapper
                condition={
                    this.props.windowDimensions.width <
                        this.props.main.desktopMinSize && useWrapper
                }
                wrapper={(children: JSX.Element[] | JSX.Element) => (
                    <div className="mob-p-x-spacer-md">
                        <p className="sec-font font-size-12 ec-text-grey m-spacer-none m-t-spacer-md mob-font-size-16">
                            All {filter.label}
                        </p>
                        {children}
                    </div>
                )}
                key={`${filterSlugName}-${Date()}`}
            >
                <ConditionalWrapper
                    condition={filter.displayType !== "demographicSelector"}
                    wrapper={(children: JSX.Element[] | JSX.Element) => (
                        <div
                            className={classnames("flex flex-wrap", {
                                "xl-list-p-b overflow-auto-mob hide-scrollbars":
                                    this.props.windowDimensions.width <
                                    this.props.main.desktopMinSize,
                                "ht-1000":
                                    this.props.windowDimensions.width <
                                        this.props.main.desktopMinSize &&
                                    filter.extraParams &&
                                    filter.extraParams["mobileSize"] &&
                                    filter.extraParams["mobileSize"] ===
                                        "large",
                            })}
                        >
                            {children}
                        </div>
                    )}
                >
                    {content}
                </ConditionalWrapper>
            </ConditionalWrapper>
        );
    };

    renderListOptions(
        filter: eGroupFilter,
        filterSlugName: string,
        removeOnClickSelected: boolean,
        extraContent?: ReactNode
    ) {
        const { query, matches } = this.state;
        let contentWithNoResults: ReactNode = null;
        let showNoResults = false;
        const filterPos = _.findIndex(this.props.selectedFilters, {
            name: filter.name,
        });

        let contentWithResults = filter.values.map(
            (filterValue: egroupFilterValue, key: number) => {
                const isSelected =
                    filterPos > -1 &&
                    _.indexOf(
                        this.props.selectedFilters[filterPos].content,
                        filterValue.value.toLowerCase()
                    ) > -1;

                if (
                    filterValue.count === 0 &&
                    filterValue.value &&
                    filterValue.value !=
                        process.env.NEXT_PUBLIC_EC_TORONTO_CAMPUS_VALUE
                ) {
                    return null;
                }

                return this.searchListItemToShow(
                    key,
                    filterValue,
                    isSelected,
                    filterSlugName,
                    filter.name,
                    removeOnClickSelected
                );
            }
        );

        if (
            (query[filter.name] && !_.isEmpty(matches[filter.name])) ||
            query[filter.name]
        ) {
            contentWithResults = matches[filter.name].map(
                (value: egroupFilterValue, key: number) => {
                    const isSelected =
                        filterPos > -1 &&
                        _.indexOf(
                            this.props.selectedFilters[filterPos].content,
                            value.value.toLowerCase()
                        ) > -1;

                    return this.searchListItemToShow(
                        key,
                        value,
                        isSelected,
                        filterSlugName,
                        filter.name,
                        removeOnClickSelected
                    );
                }
            );
        } else {
            contentWithNoResults = filter.values.map(
                (filterValue: egroupFilterValue, key: number) => {
                    const isSelected =
                        filterPos > -1 &&
                        _.indexOf(
                            this.props.selectedFilters[filterPos].content,
                            filterValue.value.toLowerCase()
                        ) > -1;

                    if (
                        filterValue.count !== 0 ||
                        filterValue.value ==
                            process.env.NEXT_PUBLIC_EC_TORONTO_CAMPUS_VALUE
                    ) {
                        return null;
                    }

                    showNoResults = true;

                    return this.searchListItemToShow(
                        key,
                        filterValue,
                        isSelected,
                        filterSlugName,
                        filter.name,
                        removeOnClickSelected
                    );
                }
            );
        }

        return (
            <ul
                className={classnames("p-l-spacer-none", {
                    "xl-list-p-b overflow-auto-mob ht-1000 hide-scrollbars":
                        this.props.windowDimensions.width <
                        this.props.main.desktopMinSize,
                })}
            >
                {contentWithResults}

                {contentWithNoResults && showNoResults ? (
                    <li className="no-results m-t-spacer-lg">
                        <button
                            onClick={() => {
                                this.showNoResults(filter.name);
                            }}
                            className={classnames(
                                "text-trans-alt-dark-grey no-background font-size-14 ln-height-reset cursor-pointer flex flex-align-center no-border",
                                {
                                    selected:
                                        _.indexOf(
                                            this.state.showNoResults,
                                            filter.name
                                        ) > -1,
                                }
                            )}
                        >
                            Show More&nbsp;
                            <FontAwesomeIcon
                                className={classnames("rotate font-size-14", {
                                    "text-active-blue":
                                        filterPos > -1 &&
                                        this.props.selectedFilters[filterPos]
                                            .content.length > 0 &&
                                        this.props.windowDimensions.width <
                                            this.props.main.desktopMinSize,
                                    down:
                                        _.indexOf(
                                            this.state.showNoResults,
                                            filter.name
                                        ) === -1,
                                })}
                                icon={faChevronUp}
                            />
                        </button>
                        <Transition
                            in={
                                _.indexOf(
                                    this.state.showNoResults,
                                    filter.name
                                ) > -1
                            }
                            timeout={0}
                        >
                            {(state: string | number) => (
                                <div
                                    style={{
                                        ...defaultStyleTopic,
                                        ...transitionTopicStyles[state],
                                    }}
                                >
                                    {contentWithNoResults}
                                </div>
                            )}
                        </Transition>
                    </li>
                ) : null}
                {extraContent}
            </ul>
        );
    }

    renderSwitchFilter = (filter: processedEGroupFilterContent) => {
        let icon = filter.extraParams && filter.extraParams.icon;
        let disabled = false;
        let disabledValue = false;

        if (icon !== "child") {
            icon = "filter";
        }

        const filterPos = _.findIndex(this.props.selectedFilters, {
            name: filter.name,
        });

        const filterFound = getKeyValue<
            keyof processedEGroupFilterContent,
            processedEGroupFilterContent
        >(filter.fields[0] as keyof processedEGroupFilterContent)(filter) as
            | egroupFilterValue[]
            | undefined;

        if (
            filterPos > -1 &&
            filterFound &&
            filterFound.length === 1 &&
            filterFound[0].value ===
                this.props.selectedFilters[filterPos].content[0] &&
            !this.props.selectedFilters[filterPos].content[0]
        ) {
            return null;
        }

        return this.props.windowDimensions.width <
            this.props.main.desktopMinSize ? (
            <div
                className={classnames(
                    "flex flex-justify-center p-l-spacer-md p-r-spacer-xs m-r-spacer-xs m-b-spacer-xs fit-content accordion__item " +
                        (this.props.extraSwitchFilterClass || ""),
                    {
                        "border-active-blue mob-static-pos":
                            filterPos > -1 &&
                            this.props.selectedFilters[filterPos].content[0],
                    }
                )}
                onClick={(e) => {
                    if (
                        this.props.changeFunction &&
                        _.isFunction(this.props.changeFunction)
                    ) {
                        this.props.changeFunction(filter.name, "yes");
                    }
                }}
            >
                <span
                    className={classnames("w-max-content", {
                        "text-active-blue":
                            filterPos > -1 &&
                            this.props.selectedFilters[filterPos].content[0],
                        "text-dark":
                            filterPos > -1 &&
                            !this.props.selectedFilters[filterPos].content[0],
                    })}
                >
                    {filter.label}
                </span>
                <span className="m-x-spacer-xs cursor-pointer">
                    <FontAwesomeIcon
                        // icon={[iconPrefix, icon]}
                        icon={icon as IconProp}
                        className={classnames({
                            "text-active-blue":
                                filterPos > -1 &&
                                this.props.selectedFilters[filterPos]
                                    .content[0],
                            "text-dark":
                                filterPos > -1 &&
                                !this.props.selectedFilters[filterPos]
                                    .content[0],
                        })}
                        aria-label={filter.label}
                        aria-hidden="true"
                    />
                </span>
            </div>
        ) : (
            <div
                className={
                    "flex flex-justify-between flex-align-center switch-filter-wrapper " +
                    (this.props.extraSwitchFilterClass || "")
                }
            >
                <div className="full-height flex flex-align-center">
                    <div
                        className={`flex flex-justify-center flex-align-center xs-icon ec-rounded  font-size-14 m-r-spacer-xs ${
                            filter.extraParams &&
                            filter.extraParams.iconExtraClass
                        }`}
                    >
                        <FontAwesomeIcon
                            icon={icon as IconProp}
                            className="text-white"
                            aria-label={filter.label}
                            aria-hidden="true"
                        />
                    </div>

                    <span className="font-size-16 sec-font">
                        {filter.label}
                    </span>
                </div>
                <div className={`switch-filter full-height m-r-spacer-sm`}>
                    <label className="switch full-height">
                        <input
                            type="checkbox"
                            className={(
                                filterPos > -1 &&
                                this.props.selectedFilters[filterPos].content[0]
                            )?.toString()}
                            id={`cc-egroups-search-${filter.slugName.toLowerCase()}`}
                            checked={
                                disabled
                                    ? disabledValue
                                    : filterPos > -1 &&
                                      this.props.selectedFilters[filterPos]
                                          .content[0] === "yes"
                            }
                            onChange={(e) => {
                                if (
                                    this.props.changeFunction &&
                                    _.isFunction(this.props.changeFunction)
                                ) {
                                    this.props.changeFunction(
                                        filter.name,
                                        "yes"
                                    );
                                }
                            }}
                            disabled={disabled}
                        />
                        <span className="slider round" />
                    </label>
                </div>
            </div>
        );
    };

    renderLoading = () => {
        if (
            process.browser &&
            window.screen.width < this.props.main.desktopMinSize
        ) {
            return (
                <div className="p-r-spacer-lg">
                    <div className="text-alt-dark-grey full-width animate-shimmer m-b-spacer-sm element-loading-shimmer m-y-spacer-md" />
                </div>
            );
        }

        return (
            <div className="p-r-spacer-lg">
                <div className="text-alt-dark-grey full-width animate-shimmer m-b-spacer-sm element-loading-shimmer m-y-spacer-md" />
                <div className="text-alt-dark-grey full-width animate-shimmer m-b-spacer-sm element-loading-shimmer m-y-spacer-md" />
                <div className="text-alt-dark-grey full-width animate-shimmer m-b-spacer-sm element-loading-shimmer m-y-spacer-md" />
                <div className="text-alt-dark-grey full-width animate-shimmer m-b-spacer-sm element-loading-shimmer m-y-spacer-md" />
            </div>
        );
    };

    renderRealContent = () => {
        const accordionButtonClass =
            "accordion__button mob-flex-justify-start flex sec-font full-width no-border flex-justify-spacebetween flex-align-center p-r-spacer-md mob-p-r-spacer-none " +
            (this.props.extraAccordionButtonClass || "");
        const isMobile = process.browser
            ? window.screen.width < this.props.main.desktopMinSize
            : false;
        return (
            <div
                className={
                    "accordion-wrapper mob-flex m-t-spacer-xs" +
                    (this.state.positionFixed ? " fix-pos" : "")
                }
            >
                <>
                    <Accordion
                        allowMultipleExpanded={
                            this.props.windowDimensions.width <
                            this.props.main.desktopMinSize
                                ? false
                                : true
                        }
                        allowZeroExpanded={true}
                        preExpanded={
                            this.props.windowDimensions.width >
                            this.props.main.desktopMinSize - 1
                                ? this.state.expandedFilters
                                : []
                        }
                        onChange={(expanded) => {
                            this.setState({
                                expandedFilters: expanded as string[],
                            });
                        }}
                        className="egroup-accordion mob-flex"
                    >
                        {this.props.eGroupFiltersValues &&
                            this.props.eGroupFiltersValues.filters &&
                            this.props.eGroupFiltersValues.filters.map(
                                (filterValue) => {
                                    if (filterValue.displayType === "switch") {
                                        // All switches are render outside of the Accordion
                                        return null;
                                    }

                                    const filter =
                                        this.getFilterToUse(filterValue);

                                    const getRealName = (
                                        selectedValue: string
                                    ) => {
                                        let realName = selectedValue;

                                        filter.values.forEach((value) => {
                                            if (value.value === selectedValue) {
                                                realName = value.label;
                                            }
                                        });
                                        return realName;
                                    };

                                    const selectedFilterPos = _.findIndex(
                                        this.props.selectedFilters,
                                        { name: filter.name }
                                    );
                                    const isSelected =
                                        selectedFilterPos > -1 &&
                                        this.props.selectedFilters[
                                            selectedFilterPos
                                        ] &&
                                        this.props.selectedFilters[
                                            selectedFilterPos
                                        ].content.length > 0;

                                    return (
                                        <AccordionItem
                                            id={`cc-egroups-search-${
                                                filter
                                                    ? filter.name
                                                          ?.replaceAll(" ", "-")
                                                          .toLowerCase()
                                                    : ""
                                            }-dropdown`}
                                            className={classnames(
                                                "accordion__item",
                                                {
                                                    "border-active-blue mob-static-pos":
                                                        isSelected &&
                                                        this.props
                                                            .windowDimensions
                                                            .width <
                                                            this.props.main
                                                                .desktopMinSize,
                                                }
                                            )}
                                            uuid={filter.name}
                                            key={`${filter.name}-${filter.id}`}
                                        >
                                            <AccordionItemHeading>
                                                <AccordionItemButton
                                                    className={classnames(
                                                        accordionButtonClass,
                                                        {
                                                            opened: this.state.expandedFilters.includes(
                                                                filter.name
                                                            ),
                                                            closed: !this.state.expandedFilters.includes(
                                                                filter.name
                                                            ),
                                                        }
                                                    )}
                                                >
                                                    <div
                                                        className={classnames(
                                                            "flex flex-row flex-align-center mob-m-r-spacer-sm nowrap regular not-clickable",
                                                            {
                                                                "regular prim-font":
                                                                    this.props
                                                                        .windowDimensions
                                                                        .width <
                                                                    this.props
                                                                        .main
                                                                        .desktopMinSize,
                                                                "text-active-blue":
                                                                    isSelected &&
                                                                    this.props
                                                                        .windowDimensions
                                                                        .width <
                                                                        this
                                                                            .props
                                                                            .main
                                                                            .desktopMinSize,
                                                            }
                                                        )}
                                                    >
                                                        {filter.label}{" "}
                                                        {isSelected &&
                                                        this.props
                                                            .windowDimensions
                                                            .width >
                                                            this.props.main
                                                                .desktopMinSize ? (
                                                            <div className="m-l-spacer-sm selected-filter-circle" />
                                                        ) : null}
                                                    </div>{" "}
                                                    <FontAwesomeIcon
                                                        className={classnames(
                                                            "rotate font-size-14",
                                                            {
                                                                "text-active-blue":
                                                                    isSelected &&
                                                                    this.props
                                                                        .windowDimensions
                                                                        .width <
                                                                        this
                                                                            .props
                                                                            .main
                                                                            .desktopMinSize,
                                                                down: !this.state.expandedFilters.includes(
                                                                    filter.name
                                                                ),
                                                            }
                                                        )}
                                                        icon={faChevronUp}
                                                    />
                                                </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel
                                                className={classnames(
                                                    "accordion__panel flex flex-wrap " +
                                                        (this.props
                                                            .extraAccordionPanelClass ||
                                                            ""),
                                                    {
                                                        "ec-top-border-radius-xxl open":
                                                            this.props
                                                                .windowDimensions
                                                                .width <
                                                                this.props.main
                                                                    .desktopMinSize &&
                                                            this.state.expandedFilters.includes(
                                                                filter.name
                                                            ),
                                                        "background-white fix-pos stayleft full-width full-height all-the-way-forward":
                                                            this.props
                                                                .windowDimensions
                                                                .width <
                                                            this.props.main
                                                                .desktopMinSize,
                                                        small:
                                                            !filter.extraParams ||
                                                            !filter.extraParams[
                                                                "mobileSize"
                                                            ] ||
                                                            (filter.extraParams &&
                                                                filter
                                                                    .extraParams[
                                                                    "mobileSize"
                                                                ] &&
                                                                filter
                                                                    .extraParams[
                                                                    "mobileSize"
                                                                ] !== "large"),
                                                    }
                                                )}
                                            >
                                                <ConditionalWrapper
                                                    condition={
                                                        this.props
                                                            .windowDimensions
                                                            .width <
                                                            this.props.main
                                                                .desktopMinSize &&
                                                        this.state.expandedFilters.includes(
                                                            filter.name
                                                        )
                                                    }
                                                    wrapper={(
                                                        children:
                                                            | JSX.Element[]
                                                            | JSX.Element
                                                    ) => (
                                                        <ClickAwayListener
                                                            className="full-width"
                                                            onClickAway={() =>
                                                                this.collapseAccordion()
                                                            }
                                                        >
                                                            {children}
                                                        </ClickAwayListener>
                                                    )}
                                                >
                                                    <Transition
                                                        in={this.state.expandedFilters.includes(
                                                            filter.name
                                                        )}
                                                        timeout={duration}
                                                    >
                                                        {(
                                                            state:
                                                                | string
                                                                | number
                                                        ) => (
                                                            <div
                                                                className="full-width"
                                                                style={{
                                                                    ...defaultStyle,
                                                                    ...transitionStyles[
                                                                        state
                                                                    ],
                                                                }}
                                                            >
                                                                {this.props
                                                                    .windowDimensions
                                                                    .width <
                                                                    this.props
                                                                        .main
                                                                        .desktopMinSize && (
                                                                    <div className="flex flex-justify-between b-x-width-none b-t-width-none b-b-width-xs border-off-white p-t-spacer-lg p-x-spacer-lg">
                                                                        <h3 className="text-dark sec-font bold font-size-24 m-spacer-none">
                                                                            {
                                                                                filter.label
                                                                            }
                                                                        </h3>
                                                                        <button
                                                                            onClick={() =>
                                                                                this.collapseAccordion()
                                                                            }
                                                                            className="no-border ec-no-background text-dark no-outline sec-font bold p-spacer-none font-size-14 mob-font-size-16"
                                                                        >
                                                                            Done
                                                                        </button>
                                                                    </div>
                                                                )}
                                                                <div className="flex flex-wrap full-width">
                                                                    <Transition
                                                                        in={
                                                                            isSelected
                                                                        }
                                                                        timeout={
                                                                            duration
                                                                        }
                                                                    >
                                                                        {(
                                                                            state:
                                                                                | string
                                                                                | number
                                                                        ) => (
                                                                            <div
                                                                                style={{
                                                                                    ...defaultStyle,
                                                                                    ...transitionStyles[
                                                                                        state
                                                                                    ],
                                                                                }}
                                                                                className="flex flex-justify-spacebetween flex-row full-width m-t-spacer-sm mob-flex-align-center mob-p-x-spacer-md p-r-spacer-md"
                                                                            >
                                                                                <div className="filter-clear font-size-14 not-clickable">
                                                                                    {filter.maxSelection &&
                                                                                    filter.maxSelection ===
                                                                                        1 ? (
                                                                                        <span>
                                                                                            {getRealName(
                                                                                                isSelected &&
                                                                                                    this
                                                                                                        .props
                                                                                                        .selectedFilters[
                                                                                                        selectedFilterPos
                                                                                                    ]
                                                                                                    ? this
                                                                                                          .props
                                                                                                          .selectedFilters[
                                                                                                          selectedFilterPos
                                                                                                      ]
                                                                                                          .content[0]
                                                                                                    : ""
                                                                                            )}
                                                                                        </span>
                                                                                    ) : isSelected ? (
                                                                                        this
                                                                                            .props
                                                                                            .selectedFilters[
                                                                                            selectedFilterPos
                                                                                        ]
                                                                                            .content
                                                                                            .length
                                                                                    ) : (
                                                                                        ""
                                                                                    )}
                                                                                    &nbsp;selected
                                                                                </div>
                                                                                <button
                                                                                    id={`cc-egroups-search--${
                                                                                        filter
                                                                                            ? filter.name
                                                                                                  ?.replaceAll(
                                                                                                      " ",
                                                                                                      "-"
                                                                                                  )
                                                                                                  .toLowerCase()
                                                                                            : ""
                                                                                    }-clear`}
                                                                                    onClick={() => {
                                                                                        if (
                                                                                            this
                                                                                                .props
                                                                                                .clearFunction &&
                                                                                            _.isFunction(
                                                                                                this
                                                                                                    .props
                                                                                                    .clearFunction
                                                                                            )
                                                                                        ) {
                                                                                            this.props.clearFunction(
                                                                                                filter.name
                                                                                            );
                                                                                        }
                                                                                    }}
                                                                                    className="filter-clear-btn regular no-border ec-no-background no-outline prim-font p-spacer-none font-size-14 mob-font-size-16"
                                                                                >
                                                                                    Clear
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </Transition>
                                                                    {this.getFilterContent(
                                                                        filter
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Transition>
                                                </ConditionalWrapper>
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                    );
                                }
                            )}
                    </Accordion>

                    {this.props.eGroupFiltersValues &&
                        this.props.eGroupFiltersValues.filters &&
                        this.props.eGroupFiltersValues.filters
                            .filter((filter) => {
                                return (
                                    filter.displayType === "switch" &&
                                    filter.fields[0] &&
                                    filter[
                                        filter
                                            .fields[0] as keyof processedEGroupFilterContent
                                    ] &&
                                    (
                                        filter[
                                            filter
                                                .fields[0] as keyof processedEGroupFilterContent
                                        ] as string[]
                                    )?.length === 2
                                );
                            })
                            .map((filter, index) => {
                                return (
                                    <div key={`${filter.name}-${index}`}>
                                        {this.renderSwitchFilter(filter)}
                                    </div>
                                );
                            })}

                    {isMobile &&
                    !_.isEmpty(this.props.mobileRedirectToOtherViewIcon) &&
                    this.props.mobileRedirectToOtherViewUrl ? (
                        <a
                            className="flex flex-wrap flex-justify-center p-l-spacer-md p-r-spacer-xs flex-align-center m-r-spacer-xs fit-content accordion__item m-no-border prim-font ec-primary-font--regular mobile-redirect-to-other-view"
                            href={this.props.mobileRedirectToOtherViewUrl}
                        >
                            <FontAwesomeIcon
                                icon={
                                    this.props
                                        .mobileRedirectToOtherViewIcon as IconProp
                                }
                                className="text-active-blue"
                            />

                            <div className="nowrap ln-height-reset font-size-14 text-active-blue">
                                {this.props.mobileRedirectToOtherViewTitle ||
                                    ""}
                            </div>
                        </a>
                    ) : null}
                </>
            </div>
        );
    };

    render() {
        let content = this.renderLoading();

        if (this.props.isLoaded) {
            content = this.renderRealContent();
        }

        return (
            <>
                {!_.isEmpty(this.state.expandedFilters) &&
                    this.props.windowDimensions.width <
                        this.props.main.desktopMinSize && (
                        <div className="background-trans-dark-grey way-forward fix-pos abs-center full-width full-height" />
                    )}
                <div
                    ref={this.sideBarRef}
                    className={classnames(
                        "filters p-y-spacer-xl " +
                            (this.props.extraWrapperFiltersClass || ""),
                        {
                            "extra-high":
                                this.props.windowDimensions.width >
                                    this.props.main.desktopMinSize - 1 &&
                                this.props.isScollAfterHeader,
                            "sticky-pos uptop":
                                this.props.windowDimensions.width >
                                    this.props.main.desktopMinSize - 1 &&
                                !this.props.isLoading &&
                                this.props.isLoaded,
                            "hide-scrollbars mob-p-t-spacer-none mob-p-b-spacer-sm mob-p-l-spacer-sm":
                                this.props.windowDimensions.width <
                                this.props.main.desktopMinSize,
                            overflowing:
                                _.isEmpty(this.state.expandedFilters) &&
                                this.props.windowDimensions.width <
                                    this.props.main.desktopMinSize,
                            "no-overflow":
                                this.props.windowDimensions.width <
                                    this.props.main.desktopMinSize &&
                                !_.isEmpty(this.state.expandedFilters),
                        }
                    )}
                >
                    {this.props.windowDimensions.width >
                        this.props.main.desktopMinSize - 1 && (
                        <Image
                            className={
                                "m-b-spacer-md " +
                                (this.props.extraLogoClass || "")
                            }
                            layout="fixed"
                            width={129.98}
                            height={49}
                            objectFit={"contain"}
                            objectPosition={"center"}
                            src={
                                "https://dv9pmwasxvawj.cloudfront.net/images/connection_center/eGroups/eGroups-Logo.svg"
                            }
                            alt="eGroups logo"
                        />
                    )}
                    <div className="b-x-width-none b-b-width-none b-t-width-xs border-main-grey mob-b-width-none">
                        {content}
                    </div>
                </div>
            </>
        );
    }
}
